import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, description, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.22em] text-primary-400 uppercase">
            <span className="w-6 h-px bg-primary-500/70"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="mt-2 font-heading font-extrabold text-xl md:text-3xl text-foreground-950">{title}</h2>
        {description && <p className="mt-2 text-sm text-foreground-600 max-w-2xl">{description}</p>}
      </div>
      {action}
    </div>
  );
}